import { render, staticRenderFns } from "./AssignmentTaskForm.vue?vue&type=template&id=7730bec8"
import script from "./AssignmentTaskForm.vue?vue&type=script&lang=js"
export * from "./AssignmentTaskForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports